var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "d-my-editor-group-form",
      class: ["readonly-" + _vm.readonly],
      attrs: {
        model: _vm.formData,
        disabled: _vm.readonly,
        "label-width": _vm.labelWidth,
        cols: _vm.cols
      }
    },
    _vm._l(_vm.editorList, function(item, index) {
      return _c(
        "el-form-item",
        {
          key: index,
          attrs: {
            label: item.label,
            rules: item.rules || {
              required: item.required,
              message: item.error.replace("$1", item.label.replace(/[:：]/, ""))
            },
            prop: item.path
          }
        },
        [
          _c(
            item.cmpName,
            _vm._g(
              _vm._b(
                {
                  ref: item.ref,
                  refInFor: true,
                  tag: "component",
                  style: { width: item.width || _vm.contentWidth },
                  model: {
                    value: _vm.formData[item.path],
                    callback: function($$v) {
                      _vm.$set(_vm.formData, item.path, $$v)
                    },
                    expression: "formData[item.path]"
                  }
                },
                "component",
                item.attrs,
                false
              ),
              item.listeners
            )
          )
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f03ee74", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f03ee74","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyEditorGroup.vue
// module id = iaag
// module chunks = 38